import React from 'react';

const logos = [
  { name: 'Snyk', abbr: 'SNYK', color: '#0E1E25' },
  { name: 'Allego', abbr: 'ALG', color: '#1D3461' },
  { name: 'Loopio', abbr: 'LPO', color: '#3B5BDB' },
  { name: 'Meritt', abbr: 'MRT', color: '#2F9E44' },
  { name: 'GreyScout', abbr: 'GRS', color: '#495057' },
  { name: 'StackOptimise', abbr: 'STO', color: '#7048E8' },
  { name: 'Datazn', abbr: 'DTZ', color: '#E67700' },
  { name: 'Firefly', abbr: 'FFA', color: '#D9480F' },
  { name: 'CMM', abbr: 'CMM', color: '#0C8599' },
  { name: 'Platinum', abbr: 'PLT', color: '#862E9C' },
];

const doubledLogos = [...logos, ...logos, ...logos];

export default function LogoStrip() {
  return (
    <div className="bg-white py-10 border-b border-gray-100 overflow-hidden">
      <p className="text-center text-xs text-gray-400 font-semibold uppercase tracking-widest mb-6">
        Trusted by 15,000+ companies worldwide
      </p>
      <div className="relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        <div className="flex animate-logo-scroll">
          {doubledLogos.map((logo, i) => (
            <div key={i} className="flex-shrink-0 mx-8 flex items-center gap-2 opacity-60 hover:opacity-100 transition-opacity cursor-pointer">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center text-white text-xs font-bold"
                style={{ backgroundColor: logo.color }}
              >
                {logo.abbr.slice(0, 2)}
              </div>
              <span className="text-sm font-semibold text-gray-700 whitespace-nowrap">{logo.name}</span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes logo-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
        .animate-logo-scroll {
          animation: logo-scroll 30s linear infinite;
          width: max-content;
        }
      `}</style>
    </div>
  );
}
